import nunjucks from 'nunjucks'

export default function renderTemplate(str = '', state = {}) {
  const template = nunjucks.compile(str)

  return template.render(state)
}
